import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getVideos, uploadVideo, createExternalVideo, updateVideo, deleteVideo } from "../../api/videoApi";
import { getImages, uploadImage, createExternalImage, updateImage, deleteImage } from "../../api/imageApi";
import { getPdfs, uploadPdf, createExternalPdf, updatePdf, deletePdf } from "../../api/pdfApi";

const AdminNewsMedia = () => {
  const [media, setMedia] = useState({ videos: [], images: [], pdfs: [] });
  const [loading, setLoading] = useState(true);
  const [newMedia, setNewMedia] = useState({ title: "", url: "", file: null, type: "", isExternal: false });
  const category = "Media";
  const navigate = useNavigate();

  useEffect(() => {
    const fetchMedia = async () => {
      try {
        const videos = await getVideos(category);
        const images = await getImages(category);
        const pdfs = await getPdfs(category);

        const sortedVideos = videos.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        setMedia({ videos: sortedVideos, images, pdfs });
      } catch (error) {
        console.error("Error fetching media:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchMedia();
  }, []);

  //   const handleCreate = async (type, isExternal) => {
  //     try {
  //         console.log(`🟢 handleCreate called - Type: ${type}, isExternal: ${isExternal}`);

  //         let createdItem;
  //         const category = "News & Media";  // ✅ Ensure category is set

  //         if (isExternal) {
  //             // Handle External Media (URL-based)
  //             const data = {
  //                 url: newMedia.url,
  //                 title: newMedia.title,
  //                 category,  // ✅ Ensure category is included
  //             };
  //             console.log("📤 Sending external media data:", data);

  //             if (type === "videos") createdItem = await createExternalVideo(data);
  //             if (type === "images") createdItem = await createExternalImage(data);
  //             if (type === "pdfs") createdItem = await createExternalPdf(data);
  //         } else {
  //             // Handle File Uploads
  //             if (!newMedia.file) {
  //                 console.error("❌ No file selected.");
  //                 alert("Please select a file before uploading.");
  //                 return;
  //             }

  //             const formData = new FormData();
  //             formData.append(type.slice(0, -1), newMedia.file); // "image" instead of "images"
  //             formData.append("title", newMedia.title);
  //             formData.append("category", category);  // ✅ Ensure category is sent

  //             console.log("📤 Sending uploaded media FormData:");
  //             for (let [key, value] of formData.entries()) {
  //                 console.log(`   ${key}:`, value);
  //             }

  //             if (type === "videos") createdItem = await uploadVideo(formData);
  //             if (type === "images") createdItem = await uploadImage(formData);
  //             if (type === "pdfs") createdItem = await uploadPdf(formData);
  //         }

  //         if (createdItem) {
  //             console.log("✅ Media created successfully:", createdItem);
  //             setMedia((prev) => ({ ...prev, [type]: [...prev[type], createdItem] }));
  //         }
  //     } catch (error) {
  //         console.error("❌ Error creating media:", error);
  //     }
  // };

  const handleCreate = async (type) => {
    try {
      console.log(`🟢 handleCreate called - Type: ${type}`);

      let createdItem;
      const category = "Media";

      if (newMedia.isExternal) {
        // Handle External Media (URL-based)
        const data = {
          url: newMedia.url,
          title: newMedia.title,
          category
        };
        console.log("📤 Sending external media data:", data);

        if (type === "videos") createdItem = await createExternalVideo(data);
        // if (type === "images") createdItem = await uploadImage(data);
        if (type === "images") createdItem = await createExternalImage(data);
        if (type === "pdfs") createdItem = await createExternalPdf(data);
      } else {
        // Handle File Uploads
        if (!newMedia.file) {
          console.error("❌ No file selected.");
          alert("Please select a file before uploading.");
          return;
        }

        const formData = new FormData();
        // formData.append(type.slice(0, -1), newMedia.file); // "image" instead of "images"
        if (type === "pdfs") {
          formData.append("pdfFile", newMedia.file); // ✅ Fix for PDFs only
        } else {
          formData.append(type.slice(0, -1), newMedia.file); // ✅ Keeps existing logic for images & videos
        }

        formData.append("title", newMedia.title);
        formData.append("category", category); // ✅ Ensure category is sent

        console.log("📤 Sending uploaded media FormData:");
        for (let [key, value] of formData.entries()) {
          console.log(`   ${key}:`, value);
        }

        if (type === "videos") createdItem = await uploadVideo(formData, category);
        if (type === "images") createdItem = await uploadImage(formData, category);
        if (type === "pdfs") createdItem = await uploadPdf(formData, category);
      }

      // if (createdItem) {
      //   console.log("✅ Media created successfully:", createdItem);
      //   setMedia((prev) => ({ ...prev, [type]: [...prev[type], createdItem] }));
      // }

      if (createdItem) {
        console.log("✅ Media created successfully:", createdItem);

        // 🔥 Fix: Ensure external PDFs have a `fileUrl`
        const updatedItem = {
          ...createdItem,
          fileUrl: createdItem.fileUrl || createdItem.pdfUrl || createdItem.url, // ✅ Fix missing fileUrl
        };

        setMedia((prev) => ({
          ...prev,
          [type]: [...prev[type], updatedItem], // ✅ Add to state immediately
        }));

        console.log("🟢 Updated Media State:", updatedItem);

        // ✅ Refetch & Sort Videos Immediately
        if (type === "videos") {
          console.log("🔄 Refetching videos...");
          const updatedVideos = await getVideos(category);
          setMedia((prev) => ({
            ...prev,
            videos: updatedVideos.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)),
          }));
        }

        // 🔥 Fix for PDFs not showing immediately
        if (type === "pdfs") {
          console.log("🔄 Refetching PDFs...");
          const updatedPdfs = await getPdfs(category);
          setMedia((prev) => ({ ...prev, pdfs: updatedPdfs }));
        }
      }
    } catch (error) {
      console.error("❌ Error creating media:", error);
    }
  };



  const handleDelete = async (id, type) => {
    try {
      if (type === "videos") await deleteVideo(id);
      if (type === "images") await deleteImage(id);
      if (type === "pdfs") await deletePdf(id);
      setMedia((prev) => ({ ...prev, [type]: prev[type].filter((item) => item._id !== id) }));
    } catch (error) {
      console.error("Error deleting:", error);
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <div className="container mx-auto p-6">
      <button
        onClick={() => navigate("/admin")}
        className="bg-gray-300 text-gray-800 px-4 py-2 rounded mb-4 hover:bg-gray-400"
      >
        ← Back to Dashboard
      </button>
      <h1 className="text-3xl font-bold mb-6">Admin - Media</h1>

      {/* Upload New Media */}
      <div className="mb-6">
        <input type="text" placeholder="Title" value={newMedia.title} onChange={(e) => setNewMedia({ ...newMedia, title: e.target.value })} className="border rounded p-2 w-full mb-2" />
        <label className="mr-4">
          <input type="radio" name="uploadType" checked={!newMedia.isExternal} onChange={() => setNewMedia({ ...newMedia, isExternal: false, url: "" })} /> Upload File
        </label>
        <label>
          <input type="radio" name="uploadType" checked={newMedia.isExternal} onChange={() => setNewMedia({ ...newMedia, isExternal: true, file: null })} /> External URL
        </label>

        {newMedia.isExternal ? (
          <input type="text" placeholder="External URL" value={newMedia.url} onChange={(e) => setNewMedia({ ...newMedia, url: e.target.value, file: null })} className="border rounded p-2 w-full mb-2" />
        ) : (
          <input
            type="file"
            onChange={(e) => {
              if (e.target.files.length > 0) {
                console.log("📸 File selected:", e.target.files[0]); // ✅ Debugging
                setNewMedia((prev) => ({
                  ...prev,
                  file: e.target.files[0], // ✅ Ensure file is set
                }));
              }
            }}
            className="border rounded p-2 w-full mb-2"
          />

        )}

        {/* Buttons */}
        <div className="flex gap-2">
          <button onClick={() => handleCreate("videos", newMedia.isExternal)} className="bg-blue-500 text-white px-4 py-2 rounded">Add Video</button>
          <button onClick={() => handleCreate("images", newMedia.isExternal)} className="bg-green-500 text-white px-4 py-2 rounded">Add Image</button>
          <button onClick={() => handleCreate("pdfs", newMedia.isExternal)} className="bg-purple-500 text-white px-4 py-2 rounded">Add PDF</button>
        </div>
      </div>

      {/* Display Media */}
      {["videos", "images", "pdfs"].map((type) => (
        <div key={type} className="mb-6">
          <h2 className="text-2xl font-semibold mb-4">{type.charAt(0).toUpperCase() + type.slice(1)}</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {media[type]?.map((item) => (
              <div key={item._id} className="border p-4 rounded shadow-md flex flex-col">

                {/* {type === "videos" && (
                  <video className="w-full mt-2 rounded" controls>
                    <source src={item.fileUrl ? `http://localhost:5555${item.fileUrl}` : item.url} type="video/mp4" />
                  </video>
                )} */}
                {type === "videos" && (
                  item.fileUrl ? (
                    // <video className="w-full mt-2 rounded" controls>
                    <video className="w-full rounded-md shadow-lg" controls>
                      <source src={`http://localhost:5555${item.fileUrl}`} type="video/mp4" />
                    </video>
                  ) : (
                    <iframe
                      // className="w-full mt-2 rounded"
                      className="w-full h-40 rounded-md"
                      //This is the change from regular videos to YouTube
                      // src={item.url}
                      src={item.url.replace("watch?v=", "embed/")}
                      title={item.title}
                      allowFullScreen
                    />
                  )
                )}

                {type === "images" && (
                  // <img
                  //   className="w-full mt-2 rounded"
                  //   // src={`http://localhost:5555${item.fileUrl}`}
                  //   src={item.fileUrl ? `http://localhost:5555${item.fileUrl}` : item.url}
                  //   alt={item.title}
                  // />
                  <img
                    className="w-full h-auto rounded-md mt-2 object-cover"
                    src={item.imageUrl}  // ✅ Fix: This ensures both uploaded & external images show correctly
                    alt={item.title || "Uploaded Image"}
                    onError={(e) => (e.target.src = "/default-placeholder.png")}  // ✅ Fallback for broken images
                  />

                )}

                <h3 className="text-lg font-semibold text-center">{item.title}</h3>
                {/* {type === "pdfs" && (
                  <a className="text-blue-500 hover:underline mt-2 block" href={item.fileUrl ? `http://localhost:5555${item.fileUrl}` : item.url} target="_blank" rel="noopener noreferrer">
                    View PDF
                  </a>
                )} */}
                {/* {type === "pdfs" && (
                  <button
                    onClick={() => {
                      console.log("🛠 Full PDF Item:", item);
                      console.log("📂 Opening PDF URL:", item.pdfUrl); // ✅ Debugging

                      if (item.pdfUrl) {
                        window.open(item.pdfUrl, "_blank", "noopener,noreferrer");
                      } else {
                        console.error("❌ No valid PDF URL found!");
                      }
                    }}
                    className="text-blue-500 hover:underline"
                  >
                    {item.title || "View PDF"}
                  </button>
                )} */}
                {/* {type === "pdfs" && (
  <button
    onClick={() => {
      console.log("🛠 Full PDF Item:", item);
      console.log("📂 Opening PDF URL:", item.pdfUrl || item.url); // ✅ Debugging output

      const pdfLink = item.pdfUrl || item.url;
      if (pdfLink) {
        window.open(pdfLink, "_blank", "noopener,noreferrer");
      } else {
        alert("❌ PDF link is missing.");
      }
    }}
    className="text-blue-500 hover:underline"
  >
    {item.title || "View PDF"}
  </button>
)} */}

                {/* {type === "pdfs" && (
  <button
    onClick={() => {
      console.log("🛠 Full PDF Item:", item); // ✅ Debugging full object
      const pdfUrl = item.pdfUrl || item.url; // ✅ Ensure external PDFs open correctly

      if (pdfUrl) {
        console.log("📂 Opening PDF URL:", pdfUrl);
        window.open(pdfUrl, "_blank", "noopener,noreferrer");
      } else {
        console.error("❌ No valid PDF URL found!");
        alert("PDF link is missing.");
      }
    }}
    className="text-blue-500 hover:underline"
  >
    {item.title || "View PDF"}
  </button>
)} */}

                {type === "pdfs" && (
                  <button
                    onClick={() => {
                      console.log("📄 Full PDF Item:", item); // Debugging
                      // const pdfLink = item.fileUrl || item.url; // ✅ Fix: Use correct URL field
                      let pdfLink = item.fileUrl || item.pdfUrl || item.url;
                      console.log("📂 Checking PDF URL:", pdfLink); // Debugging

                      if (pdfLink && !pdfLink.startsWith("http")) {
                        pdfLink = `http://localhost:5555${pdfLink}`;
                      }

                      console.log("Opening PDF URL:", pdfLink);

                      if (pdfLink) {
                        window.open(pdfLink, "_blank", "noopener,noreferrer");
                      } else {
                        alert("PDF link is missing.");
                        console.error("❌ No valid PDF URL found!", item);
                      }
                    }}
                    className="text-blue-500 hover:underline"
                  >
                    {item.title || "View PDF"}
                  </button>
                )}






                <div className="flex justify-between mt-2">
                  <button className="bg-red-500 text-white p-2 rounded" onClick={() => handleDelete(item._id, type)}>Delete</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AdminNewsMedia;
